import React from 'react';
import { Box } from '../Box/Box';
export var Well = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'gray' : _props$color;
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: color === 'yellow' ? 'yellow-lightest' : 'neutral-lightest',
    className: className,
    ref: ref
  }, children);
});
Well.displayName = 'Well';